import { render, staticRenderFns } from "./HdsOverlay.vue?vue&type=template&id=16554eb3&scoped=true&"
import script from "./HdsOverlay.vue?vue&type=script&lang=ts&"
export * from "./HdsOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./HdsOverlay.vue?vue&type=style&index=0&id=16554eb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16554eb3",
  null
  
)

export default component.exports